/**
 * Blur intensity configuration sourced from env vars (VI-446).
 * Defaults match the values specified in the Jira ticket.
 */

const DEFAULT_WEBGL2_INTENSITY = 26;
const DEFAULT_SELFIE_SEG_INTENSITY = 17;

export const getWebGL2BlurIntensity = (): number => {
  const raw = Number(import.meta.env.VITE_BLUR_INTENSITY_WEBGL2);
  return Number.isFinite(raw) && raw > 0 ? raw : DEFAULT_WEBGL2_INTENSITY;
};

export const getSelfieSegBlurIntensity = (): number => {
  const raw = Number(import.meta.env.VITE_BLUR_INTENSITY_SELFIE_SEG);
  return Number.isFinite(raw) && raw > 0 ? raw : DEFAULT_SELFIE_SEG_INTENSITY;
};
